export class EphesoIncome {
  codeAndamento: string;
  value: number;
  incomeFrequency: string;
  net: boolean;
}
